
export enum PollerRetryState {
    RESOLVE_WITH_DATA = 1,
    REJECT_WITH_DATA = 2,
    RETRY = 3,
}

export default class PollerPayload {
    constructor(
        public readonly pollPromise: (currentAttempt: number) => Promise<any>,
        public readonly resultValidatorPromise: (data: any) => Promise<any>,
        public readonly pollWaitIntervalMs: number,
        public readonly pollMaxRetryAttempt: number,
        public readonly serverPollWaitIntervalMs: number | null) {

    }
}
